import Logo from "./Logo";
import NavMenu from "./NavMenu";

const Sidebar = ({ leftSidebar }: any) => {
  return (
    <aside className={`sidebar sidebar-left ${leftSidebar ? "active" : ""}`}>
      <Logo name="Fixity" leftSidebar={leftSidebar} />
      <NavMenu leftSidebar={leftSidebar} />
    </aside>
  );
};

export default Sidebar;
